export enum MenuPositionEnum {
    Top = 'top',
    Bottom = 'bottom',
    BottomRight = 'bottom-right'
}